<script setup>
import sampleData from '/app/utils/sample-game-dash-data';
import NotificationHelpfulTip from './notification/HelpfulTip.vue';
import { UseVirtualList } from '@vueuse/components';
import { computed, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { orderBy } from 'lodash';
import { bus } from '/app/plugins/bus';
import { useAuth } from '/app/composables/auth';

const props = defineProps({
    role: String,
    height: {
        type: String,
        default: '160px',
    },
});

const { t } = useI18n();
const { auth } = useAuth();

const items = ref(sampleData);

const tasks = computed(() => {
    return orderBy(items.value.tasks, ['issuedAt'], ['desc']).filter(item => {
        return props.role === 'overall' || item.targetGameDash.includes(props.role);
    }).map(item => {
        const role = item.targetGameDash.split(',')[0];

        return Object.assign({}, item, {
            class: `is-${role}`,
            title: item.object,
            actionTitle: `${item.subject} ${item.actionToPerform}`,
            icon: item.icon,
            action: item.action ? () => item.action({ bus, auth }) : () => {},
            route: item.route
        });
    });
});

watch(tasks, (items) => {
    if (items.length) {
        const n = Math.floor(Math.random() * items.length);
        bus('latest-notifications:new', {
            type: 'helpful-tip',
            detail: items[n],
        });
    }
}, { immediate: true });
</script>

<template>
    <div>
        <div v-if="tasks.length" class="overflow-x-hidden">
            <UseVirtualList :list="tasks" :options="{ itemHeight: 100, overscan: 3 }" :height="height" class="sb-tight sb-rounded sb-dust-700">
                <template #="{ data: item }">
                    <NotificationHelpfulTip :detail="item" class="mb-2" />
                </template>
            </UseVirtualList>
        </div>
        <p v-else :style="{ height }" class="p-4 text-dust text-center flex items-center justify-center">
            {{ $t('component.game-dash.highlights.no-tips') }}
        </p>
    </div>
</template>
